import ReactModal from 'react-modal';
import { deprecated } from '../constants/texts';

export default class ReactModalDeprecated extends React.PureComponent {
  componentDidMount() {
    console.warn('React Modal -- ', deprecated);
  }

  render() {
    return <ReactModal {...this.props} />;
  }
}
